import styles from "./Title.module.css";

const Title = () => {
  return (
    <>
      <header className={styles.header}>
        <h1>Our Menu</h1>
      </header>
    </>
  );
};

export default Title;
